module.exports = __webpack_public_path__ + "img/n-h-page2-2.acb1ede6.png";